export const shadows = [
  {
    value: "box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;",
    author: "by 3drops",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px, rgba(51, 51, 51, 1) 0px 0px 0px 3px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;",
    author: "by Sketch",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;",
    author: "by Sketch",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;",
    author: "by Sketch",
  },
  {
    value: "box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;",
    author: "by Stripe",
  },
  {
    value:
      "box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    author: "by Stripe",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    author: "by Stripe",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    author: "by Stripe",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;",
    author: "by Stripe",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
    author: "by Stripe",
  },
  {
    value: "box-shadow: rgba(38, 57, 77, 1) 0px 20px 30px -10px;",
    author: "by Stripe",
  },
  {
    value:
      "box-shadow: rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;",
    author: "by Stripe",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;",
    author: "by Material",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;",
    author: "by Material",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;",
    author: "by Material",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;",
    author: "by Material",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;",
    author: "by Material",
  },
  {
    value:
      "box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
    author: "by Material",
  },
  {
    value:
      "box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;",
    author: "by Material",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;",
    author: "by Tailwind CSS",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
    author: "by Tailwind CSS",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;",
    author: "by Tailwind CSS",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;",
    author: "by Tailwind CSS",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;",
    author: "by Tailwind CSS",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;",
    author: "by Tailwind CSS",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;",
    author: "by Tailwind CSS",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;",
    author: "by Tailwind CSS",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;",
    author: "by Tobias Ahlin",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;",
    author: "by Tobias Ahlin",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;",
    author: "by feedback.fish",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px;",
    author: "by Alligator",
  },
  {
    value:
      "box-shadow: rgba(240, 46, 170, 0.4) 0px 5px, rgba(240, 46, 170, 0.3) 0px 10px, rgba(240, 46, 170, 0.2) 0px 15px, rgba(240, 46, 170, 0.1) 0px 20px, rgba(240, 46, 170, 0.05) 0px 25px;",
    author: "by Alligator",
  },
  {
    value:
      "box-shadow: rgba(240, 46, 170, 0.4) 5px 5px, rgba(240, 46, 170, 0.3) 10px 10px, rgba(240, 46, 170, 0.2) 15px 15px, rgba(240, 46, 170, 0.1) 20px 20px, rgba(240, 46, 170, 0.05) 25px 25px;",
    author: "by Alligator",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;",
    author: "by pqina.nl/doka",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset;",
    author: "by Github",
  },
  {
    value: "box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;",
    author: "by Github",
  },
  {
    value:
      "box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;",
    author: "by Facebook",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;",
    author: "by Shopify",
  },
  {
    value: "box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;",
    author: "by Shopify",
  },
  {
    value:
      "box-shadow: blue 0px 0px 0px 2px inset, rgba(255, 255, 255, 1) 10px -10px 0px -3px, rgba(31, 193, 27, 1) 10px -10px, rgba(255, 255, 255, 1) 20px -20px 0px -3px, rgba(255, 217, 19, 1) 20px -20px, rgba(255, 255, 255, 1) 30px -30px 0px -3px, rgba(255, 156, 85, 1) 30px -30px, rgba(255, 255, 255, 1) 40px -40px 0px -3px, rgba(255, 85, 85, 1) 40px -40px; border-radius: 0px;",
    author: "by Fossheim",
  },
  {
    value:
      "box-shadow: rgba(85, 91, 255, 1) 0px 0px 0px 3px, rgba(31, 193, 27, 1) 0px 0px 0px 6px, rgba(255, 217, 19, 1) 0px 0px 0px 9px, rgba(255, 156, 85, 1) 0px 0px 0px 12px, rgba(255, 85, 85, 1) 0px 0px 0px 15px; border-radius: 0px;",
    author: "by Fossheim",
  },
  {
    value:
      "box-shadow: rgba(204, 219, 232, 1) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;",
    author: "by boxshadows.com",
  },
  {
    value:
      "box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;",
    author: "by boxshadows.com",
  },
  {
    value: "box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;",
    author: "by box-shadows.co",
  },
  {
    value:
      "box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;",
    author: "by box-shadows.co",
  },
  {
    value: "box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;",
    author: "by box-shadows.co",
  },
  {
    value:
      "box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;",
    author: "by box-shadows.co",
  },
  {
    value:
      "box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;",
    author: "by box-shadows.co",
  },
  {
    value:
      "box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px;",
    author: "by box-shadows.co",
  },
  {
    value:
      "box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;",
    author: "by box-shadows.co",
  },
  {
    value:
      "box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;",
    author: "by box-shadows.co",
  },
  {
    value:
      "box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;",
    author: "by 10er.app",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;",
    author: "by wip.chat",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;",
    author: "by Airbnb",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;",
    author: "by Airbnb",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;",
    author: "by Airbnb",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px;",
    author: "by Airbnb",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;",
    author: "by ls.graphics",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.2) 0px 60px 40px -7px;",
    author: "by ls.graphics",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;",
    author: "by Lonely Planet",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;",
    author: "by Mac",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px;",
    author: "by Mac",
  },
  {
    value:
      "box-shadow: rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
    author: "by Mac",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;",
    author: "by pqina.nl/doka",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;",
    author: "by Typedream",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px; border-radius: 35px;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(209, 213, 219, 1) 0px 0px 0px 1px inset;",
    author: "cssscan",
  },
  {
    value: "box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;",
    author: "cssscan",
  },
  {
    value:
      "box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;",
    author: "by Trello",
  },
  {
    value:
      "box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;",
    author: "by Trello",
  },
  {
    value:
      "box-shadow: rgba(14, 18, 22, 0.35) 0px 10px 38px -10px, rgba(14, 18, 22, 0.2) 0px 10px 20px -15px;",
    author: "by Radix-UI",
  },
  {
    value:
      "box-shadow: rgba(219, 74, 255, 0.26) -5px 0px 29px 1px, rgba(23, 255, 199, 0.32) 5px 0px 29px 1px;",
    author: "by WorkOS",
  },
];
